const angel = {
    path: 'angel',
    name: 'angel',
    component: () => import("@/views/home/angel/angel.vue"),
    // component: resolve => require(['@/views/home/angel/angel.vue'], resolve), 
    children: [
        {
            path: 'index',
            meta: {
              tabBar: false,
            },
            component: () => import("@/views/home/angel/index.vue"),
        }, // 美丽天使首页
        {
            path: 'angel-mall',
            meta: {
              tabBar: false,
              useKeepAlive:true
            },
            component: () => import("@/views/home/angel/angel-mall.vue"),
        }, // 天使商城
        {
           path: 'angel-division',
           meta: {
             tabBar: false,
           },
           component: () => import("@/views/home/angel/angel-division.vue"),
        }, // 28元领皂专区列表
        {
           path: 'angel-about',
           meta: {
             tabBar: false,
           },
           component: () => import("@/views/home/angel/angel-about.vue"),
        }, // 关于富勒烯
        {
           path: 'angel-similar',
           meta: {
             tabBar: false,
           },
           component: () => import("@/views/home/angel/angel-similar.vue"),
        }, // 关于富勒烯
    ]
};

export default angel;